import { Controller } from "@hotwired/stimulus"

// Мобильное off-canvas меню. Класс `open` (sb-open) вешается на корневой
// элемент контроллера (.wa-frame): бургер открывает, бекдроп / Esc / клик
// по пункту навигации закрывают. На широких экранах CSS игнорирует класс.
export default class extends Controller {
  static classes = ["open"]

  open() {
    this.element.classList.add(...this.openClasses)
  }

  close() {
    this.element.classList.remove(...this.openClasses)
  }

  closeOnEsc(event) {
    if (event.key === "Escape") this.close()
  }
}
